import { render, staticRenderFns } from "./SNTable.vue?vue&type=template&id=c2b988ea"
import script from "./SNTable.vue?vue&type=script&lang=js"
export * from "./SNTable.vue?vue&type=script&lang=js"
import style0 from "./SNTable.vue?vue&type=style&index=0&id=c2b988ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports